import styled from '@emotion/styled';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../layout/AppLayout';
import { HeaderProjects as Header } from '../layout/Header';
import { SubscriptionButtonWithIcon, WhiteButton } from '../ui/Button';
import { ReactComponent as Illu } from '../ui/icons/Ilu abonnement.svg';

const StyledContainer = styled(Box)`
  padding: 32px;
  max-width: 1400px;
  width: 100%;
  margin: auto;
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
`;

const BulletItem = ({ text }: { text: string }) => (
  <Stack direction="row" spacing={2} alignItems="center">
    <CheckCircleIcon sx={{ color: 'var(--purple)' }} fontSize="small" />
    <Typography variant="body1" sx={{ fontSize: '20px' }}>
      {text}
    </Typography>
  </Stack>
);

const Subscription = () => {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();

  const handleSubscribe = () => {
    navigate('/checkout');
  };

  const handleKnowMore = () => {
    window.open(
      `${t('common:subscription.presentationPage.knowMoreLink')}`,
      '_blank',
    );
  };

  return (
    <AppLayout header={<Header />}>
      <StyledContainer>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Stack spacing={4}>
              <Stack spacing={0}>
                <Typography variant="h3" sx={{ fontFamily: 'Ibrand' }}>
                  {t('common:subscription.presentationPage.title')}
                </Typography>
                <Typography variant="h5" sx={{ color: 'var(--grey)' }}>
                  {t('common:subscription.presentationPage.subtitle')}
                </Typography>
              </Stack>

              <Stack spacing={1} sx={{ my: 10 }}>
                <BulletItem
                  text={t('common:subscription.presentationPage.bullet1')}
                />
                <BulletItem
                  text={t('common:subscription.presentationPage.bullet2')}
                />
                <BulletItem
                  text={t('common:subscription.presentationPage.bullet3')}
                />
              </Stack>
              <Stack direction="column" spacing={1}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1,
                    mt: 2,
                  }}
                >
                  <SubscriptionButtonWithIcon
                    onClick={handleSubscribe}
                    sx={{ width: '50%', height: '40px', fontSize: '22px' }}
                  >
                    {t(
                      'common:subscription.presentationPage.subscriptionButton',
                    )}
                  </SubscriptionButtonWithIcon>
                  <WhiteButton
                    onClick={handleKnowMore}
                    sx={{ width: '50%', height: '40px', fontSize: '22px' }}
                  >
                    {t('common:subscription.presentationPage.knowMoreButton')}
                  </WhiteButton>
                </Box>
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Illu style={{ width: '100%', height: 'auto' }} />
          </Grid>
        </Grid>
      </StyledContainer>
    </AppLayout>
  );
};

export default Subscription;
